import _ from 'lodash'
import store from '@/store'
import libPhoneNumber from 'google-libphonenumber'
import moment from 'moment-timezone'

function formatPrice(n) {
  if (_.isNil(n)) {
    return null
  }
  const currentLanguage = _.get(store, 'getters.currentLanguage')
  if(currentLanguage) {
    return Number(n).toLocaleString(currentLanguage.isoCode, { style: 'currency', currency: currentLanguage.regionInfo.isoCurrencySymbol })
  }
  return n
}

function formatPhoneNumber(n) {
  const phoneUtil = libPhoneNumber.PhoneNumberUtil.getInstance()
  try {
    const number = phoneUtil.parseAndKeepRawInput(n, store.getters.currentLanguage.regionInfo.twoLetterISORegionName)
    return phoneUtil.format(number, libPhoneNumber.PhoneNumberFormat.INTERNATIONAL)
  } catch(e) {
    return n
  }
}

function formatDate(timestamp, format = 'LLL') {
  if(!moment(timestamp).isValid()) {
    return null
  }
  const timeZone = _.get(store, 'getters.currentUserCompany.timeZone') || moment.tz.guess()
  const result = moment.utc(timestamp).tz(timeZone).format(format)
  return result
}

function template(template, data) {
  var compiled = _.template(template, { interpolate: /{([\s\S]+?)}/g })
  return compiled(data)
}

export { formatPrice, template, formatPhoneNumber, formatDate }
